export default __webpack_public_path__ + "img/1213d43917d866cb5f52c7021e5701f2.wav";